<!-- divisions -->
<template>
  <div class="divisions" :class="{ 'no-margin': isValidPassAndCenteredQR }">
    <div
      v-for="(division, index) in divisions"
      :key="index"
      :class="
        division.division == 'child' ? 'division_child_emphasis' : 'division'
      "
    >
      <div v-if="isValidPassAndCenteredQR" class="centered-qr-label">
        <div>{{ division.label }}（{{ division.label_en }}）</div>
      </div>
      <div v-else class="default-label">
        <div>{{ division.label }}</div>
        <div>{{ division.label_en }}</div>
      </div>
      <div
        class="value"
        :class="{
          'centered-qr-value': isValidPassAndCenteredQR,
          'default-value': !isValidPassAndCenteredQR,
        }"
      >
        {{ division.count }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BgFaceDivisionCountDisp",
  props: {
    divisions: {
      type: Array,
      required: true,
    },
    isValidPassAndCenteredQR: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.divisions {
  display: flex;
  margin-top: 6px;
  margin-bottom: 6px;

  &.no-margin {
    margin-top: 0;
    margin-bottom: 0;
  }

  @media screen and (min-height: 760px) {
    margin-top: 12px;
  }
}
.division {
  margin-right: 20px;
}
.division_child_emphasis {
  margin-top: -8px;
  margin-right: 20px;
  color: red;
  border: 2px solid red;
  border-radius: 10px;
  padding: 5px 10px;
}

.default-label {
  font-size: 3vw;
  line-height: 21px;
}

.default-value {
  margin-top: 3px;
  font-size: 5.5vw;
  font-weight: bold;

  @media screen and (min-height: 760px) {
    font-size: 8vw;
  }
}
</style>
